const consent = {
  title: "ประกันเดินทางต่างประเทศ (ตามไลฟ์สไตล์)",
  description: `ประกันเดินทางต่างประเทศ…เที่ยวสบายใจได้ทุก “Life Style” ไม่ว่าเที่ยวกับครอบครัว หรือไปกับแก๊งเพื่อน ผู้ที่เดินทางท่องเที่ยวทุกเพศ ทุกวัย คุ้มครองตั้งแต่อายุ 1 – 80 ปี
  <br/><br/>
  ประเทศปลายทางที่ไม่คุ้มครอง : เกาหลีเหนือ, คิวบา, ซีเรีย, ซูดาน, บุรุนดี, ปากีสถาน, ปาเลสไตน์, รวันดา, ลิเบีย, เลบานอน, ไลบีเรีย, อัฟกานิสถาน, อาเซอร์ไบจาน, อิรัก, อิสราเอล, อิหร่าน, อุซเบกิสถาน, เอธิโอเปีย, เอริเทรีย, แองโกลา, แอลจีเรีย และเฮติ`,
  benefits: [
    {
      title: "แผนรายครอบครัว",
      detail: "ความคุ้มครอง",
      items: [
        {
          index:
            "1. การเสียชีวิต การสูญเสียอวัยวะ สายตา หรือทุพพลภาพ ถาวรสิ้นเชิงเนื่องจากอุบัติเหตุ",
          ranges: [
            {
              name: "ผู้เอาประกันภัยอายุ 1 - 75 ปี",
              plans: [
                {
                  name: "Eco Plus",
                  price: "1,500,000",
                },
                {
                  name: "Best",
                  price: "3,000,000",
                },
              ],
            },
            {
              name: "ผู้เอาประกันภัยอายุ 76 - 80 ปี",
              plans: [
                {
                  name: "Eco Plus",
                  price: "1,500,000",
                },
                {
                  name: "Best",
                  price: "2,000,000",
                },
              ],
            },
          ],
        },
        {
          index: "2. การรักษาพยาบาลในต่างประเทศจากอุบัติเหตุและเจ็บป่วย",
          ranges: [
            {
              name: "ผู้เอาประกันภัยอายุ 1 - 75 ปี",
              plans: [
                {
                  name: "Eco Plus",
                  price: "2,000,000",
                },
                {
                  name: "Best",
                  price: "3,000,000",
                },
              ],
            },
            {
              name: "ผู้เอาประกันภัยอายุ 76 - 80 ปี",
              plans: [
                {
                  name: "Eco Plus",
                  price: "1,500,000",
                },
                {
                  name: "Best",
                  price: "2,000,000",
                },
              ],
            },
          ],
        },
        {
          index: "3. การรักษาพยาบาลต่อเนื่องในประเทศไทย",
          ranges: [
            {
              name: "ผู้เอาประกันภัยอายุ 1 - 75 ปี",
              plans: [
                {
                  name: "Eco Plus",
                  price: "150,000",
                },
                {
                  name: "Best",
                  price: "200,000",
                },
              ],
            },
            {
              name: "ผู้เอาประกันภัยอายุ 76 - 80 ปี",
              plans: [
                {
                  name: "Eco Plus",
                  price: "75,000",
                },
                {
                  name: "Best",
                  price: "75,000",
                },
              ],
            },
          ],
        },
        {
          index:
            "4. ผลประโยชน์ชดเชยระหว่างการรักษาตัวในโรงพยาบาลในฐานะผู้ป่วยใน",
          ranges: [
            {
              name: "",
              plans: [
                {
                  name: "Eco Plus",
                  price: "-",
                },
                {
                  name: "Best",
                  price: "1,500 บ.ต่อวัน สูงสุด 30,000 บ.",
                },
              ],
            },
          ],
        },
        {
          index: "5. การเลื่อน หรือการบอกเลิกการเดินทาง",
          ranges: [
            {
              name: "",
              plans: [
                {
                  name: "Eco Plus",
                  price: "-",
                },
                {
                  name: "Best",
                  price: "300,000",
                },
              ],
            },
          ],
        },
        {
          index: "6. ค่าใช้จ่ายในการลดจำนวนวันเดินทาง",
          ranges: [
            {
              name: "",
              plans: [
                {
                  name: "Eco Plus",
                  price: "-",
                },
                {
                  name: "Best",
                  price: "300,000",
                },
              ],
            },
          ],
        },
        {
          index: "7. การจี้เครื่องบิน",
          ranges: [
            {
              name: "",
              plans: [
                {
                  name: "Eco Plus",
                  price: "-",
                },
                {
                  name: "Best",
                  price: "200,000",
                },
              ],
            },
          ],
        },
        {
          index: "8. ชดเชยความล่าช้าในการเดินทาง",
          ranges: [
            {
              name: "",
              plans: [
                {
                  name: "Eco Plus",
                  price: `1,000 บ.ทุกๆ
                                  6 ชม. สูงสุด
                                  5,000 บ.`,
                },
                {
                  name: "Best",
                  price: `6,000 บ.ทุกๆ
                                  6 ชม. สูงสุด
                                  30,000 บ.`,
                },
              ],
            },
          ],
        },
        {
          index: "9. การพลาดการต่อเที่ยวบิน",
          ranges: [
            {
              name: "",
              plans: [
                {
                  name: "Eco Plus",
                  price: "-",
                },
                {
                  name: "Best",
                  price: "15,000",
                },
              ],
            },
          ],
        },
        {
          index:
            "10. การสูญเสีย หรือความเสียหายของกระเป๋าเดินทาง หรือทรัพย์สินส่วนตัว",
          ranges: [
            {
              name: "",
              plans: [
                {
                  name: "Eco Plus",
                  price: "5,000",
                },
                {
                  name: "Best",
                  price: "40,000",
                },
              ],
            },
          ],
        },
        {
          index:
            "11. ชดเชยการสูญหายของเงินส่วนตัว (จ่ายส่วนเกินจาก 1,000 บาทแรก)",
          ranges: [
            {
              name: "",
              plans: [
                {
                  name: "Eco Plus",
                  price: "-",
                },
                {
                  name: "Best",
                  price: "3,000",
                },
              ],
            },
          ],
        },
        {
          index: "12. การล่าช้าของกระเป๋าเดินทาง*",
          ranges: [
            {
              name: "",
              plans: [
                {
                  name: "Eco Plus",
                  price: "-",
                },
                {
                  name: "Best",
                  price: "30,000",
                },
              ],
            },
          ],
        },
        {
          index: "13. ความรับผิดต่อบุคคลภายนอก",
          ranges: [
            {
              name: "",
              plans: [
                {
                  name: "Eco Plus",
                  price: "500,000",
                },
                {
                  name: "Best",
                  price: "1,500,000",
                },
              ],
            },
          ],
        },
        {
          index: "14. ความคุ้มครองเอกสารการเดินทาง",
          ranges: [
            {
              name: "",
              plans: [
                {
                  name: "Eco Plus",
                  price: "-",
                },
                {
                  name: "Best",
                  price: "25,000",
                },
              ],
            },
          ],
        },
        {
          index: "15. ผลประโยชน์การขยายระยะเวลาโดยอัตโนมัติ",
          ranges: [
            {
              name: "",
              plans: [
                {
                  name: "Eco Plus",
                  price: "30 วัน",
                },
                {
                  name: "Best",
                  price: "30 วัน",
                },
              ],
            },
          ],
        },
        {
          index:
            "16. การเคลื่อนย้ายเพื่อการรักษาพยาบาลฉุกเฉิน หรือการเคลื่อนย้ายกลับประเทศภูมิลำเนาค่าใช้จ่ายในการส่งศพ หรืออัฐิกลับประเทศภูมิลำเนา",
          ranges: [
            {
              name: "",
              plans: [
                {
                  name: "Eco Plus",
                  price: "30,000,000",
                },
                {
                  name: "Best",
                  price: "30,000,000",
                },
              ],
            },
          ],
        },
        {
          index: "17. ชดเชยค่าโทรศัพท์ในกรณีฉุกเฉิน",
          ranges: [
            {
              name: "",
              plans: [
                {
                  name: "Eco Plus",
                  price: "-",
                },
                {
                  name: "Best",
                  price: "1,000",
                },
              ],
            },
          ],
        },
        {
          index: "18. ค่าใช้จ่ายในเดินทางเพื่อเยี่ยมผู้ป่วยที่โรงพยาบาล",
          ranges: [
            {
              name: "",
              plans: [
                {
                  name: "Eco Plus",
                  price: "-",
                },
                {
                  name: "Best",
                  price: "50,000",
                },
              ],
            },
          ],
        },
      ],
      timesHeaders: ["Eco Plus", "Best"],
      times: [
        {
          day: "1-4 วัน",
          asia: {
            "Eco Plus": 496,
            Best: 1550,
          },
          worldwide: {
            "Eco Plus": "628",
            Best: "1,638",
          },
        },
        {
          day: "5-6 วัน",
          asia: {
            "Eco Plus": 567,
            Best: "1,768",
          },
          worldwide: {
            "Eco Plus": 757,
            Best: "2,190",
          },
        },
        {
          day: "7-8 วัน",
          asia: {
            "Eco Plus": 640,
            Best: "2,221",
          },
          worldwide: {
            "Eco Plus": 852,
            Best: "2,464",
          },
        },
        {
          day: "9-10 วัน",
          asia: {
            "Eco Plus": 710,
            Best: "2,468",
          },
          worldwide: {
            "Eco Plus": 946,
            Best: "2,738",
          },
        },
        {
          day: "11-14 วัน",
          asia: {
            "Eco Plus": 850,
            Best: "2,806",
          },
          worldwide: {
            "Eco Plus": "1,133",
            Best: "3,300",
          },
        },
        {
          day: "15-21 วัน",
          asia: {
            "Eco Plus": "1,063",
            Best: "3,700",
          },
          worldwide: {
            "Eco Plus": "1,417",
            Best: "4,122",
          },
        },
        {
          day: "22-31 วัน",
          asia: {
            "Eco Plus": "1,381",
            Best: "4,514",
          },
          worldwide: {
            "Eco Plus": "1,734",
            Best: "5,164",
          },
        },
        {
          day: "32-40 วัน",
          asia: {
            "Eco Plus": "1,917",
            Best: "5,843",
          },
          worldwide: {
            "Eco Plus": "2,406",
            Best: "6,401",
          },
        },
        {
          day: "41-50 วัน",
          asia: {
            "Eco Plus": "2,023",
            Best: "6,614",
          },
          worldwide: {
            "Eco Plus": "2,620",
            Best: "7,986",
          },
        },
        {
          day: "51-60 วัน",
          asia: {
            "Eco Plus": "2,191",
            Best: "7,987",
          },
          worldwide: {
            "Eco Plus": "2,855",
            Best: "8,836",
          },
        },
        {
          day: "61-70 วัน",
          asia: {
            "Eco Plus": "2,716",
            Best: "8,633",
          },
          worldwide: {
            "Eco Plus": "3,343",
            Best: "9,252",
          },
        },
        {
          day: "71-80 วัน",
          asia: {
            "Eco Plus": "3,035",
            Best: "9,633",
          },
          worldwide: {
            "Eco Plus": "3,652",
            Best: "9,905",
          },
        },
        {
          day: "81-90 วัน",
          asia: {
            "Eco Plus": "3,566",
            Best: "10,425",
          },
          worldwide: {
            "Eco Plus": "4,049",
            Best: "10,967",
          },
        },
        {
          day: "91-120 วัน",
          asia: {
            "Eco Plus": "4,350",
            Best: "11,945",
          },
          worldwide: {
            "Eco Plus": "5,254",
            Best: "11,773",
          },
        },
        {
          day: "121-150 วัน",
          asia: {
            "Eco Plus": "5,402",
            Best: "12,813",
          },
          worldwide: {
            "Eco Plus": "6,743",
            Best: "14,694",
          },
        },
        {
          day: "151-180 วัน",
          asia: {
            "Eco Plus": "6,197",
            Best: "15,470",
          },
          worldwide: {
            "Eco Plus": "7,975",
            Best: "16,395",
          },
        },
        {
          day:
            "1 ปี (ไม่เกิน 90 วันต่อการเดินทาง) Annual - Up to 90 consecutive days/trip",
          asia: {
            "Eco Plus": "3,942",
            Best: "10,634",
          },
          worldwide: {
            "Eco Plus": "5,259",
            Best: "11,518",
          },
        },
        {
          day:
            "1 ปี (ไม่เกิน 180 วันต่อการเดินทาง) Annual - Up to 180 consecutive days/trip",
          asia: {
            "Eco Plus": "7,782",
            Best: "16,862",
          },
          worldwide: {
            "Eco Plus": "9,279",
            Best: "18,066",
          },
        },
      ],
    },
  ],
  conditions: [
    {
      title: "",
      detail: "เงื่อนไขการรับประกันภัย",
      items: [
        {
          index: "1. ผู้ขอเอาประกันภัยต้องเริ่มต้นการเดินทางจากประเทศไทย",
        },
        {
          index: "2. รับประกันอายุ 1-80 ปี",
        },
        {
          index:
            "3. แผนประกันแบบรายปี คุ้มครองการเดินทางสูงสุด 90 วัน หรือ 180 วันต่อการเดินทางในแต่ละครั้ง โดยไม่จำกัดจำนวนครั้งต่อปี",
        },
        {
          index:
            "4. ผู้ขอเอาประกันภัยสามารถขอเอาประกันภัยภายใต้กรมธรรม์ประกันภัยการเดินทางนี้ได้เพียง 1 ฉบับในช่วงเวลาเดินทางเดียวกัน",
        },
        {
          index:
            "5. ผู้ขอเอาประกันภัยจะต้องเริ่มต้นเดินทางจากประเทศไทยเท่านั้น และสิ้นสุดที่ประเทศไทยเท่านั้น",
        },
        {
          index:
            "6. ผู้ขอเอาประกันภัยจะต้องมีสุขภาพแข็งแรงและสมบรูณ์ ไม่มีอวัยวะส่วนใดส่วนหนึ่งพิการ",
        },
        {
          index: "",
        },
      ],
    },
  ],
  exceptions: [
    {
      title: "",
      detail: "ข้อยกเว้นสำคัญ",
      items: [
        {
          index:
            "1. ผู้เอาประกันภัยฆ่าตัวตาย พยายามฆ่าตัวตาย หรือการทำร้ายร่างกายตนเอง",
        },
        {
          index:
            "2. สภาพที่เป็นมาก่อนการเอาประกันภัย (Pre-existing Conditions)",
        },
        {
          index:
            "3. กรณีที่ผู้เอาประกันภัยอยู่ภายใต้ฤทธิ์สุรา ยาเสพติด สารเสพติดให้โทษ",
        },
        {
          index:
            "4. สงคราม การรุกราน การกระทำที่มุ่งร้ายของศัตรูต่างชาติ หรือการกระทำที่มุ่งร้ายคล้ายสงคราม สงครามกลางเมือง การปฏิวัติ การจลาจล การนัดหยุดงาน การก่อความวุ่นวาย หรือต่อต้านรัฐบาล การประกาศกฎอัยการศึก การก่อการร้าย",
        },
        {
          index:
            "5. ขณะที่ผู้เอาประกันภัยปฏิบัติหน้าที่เป็นนักบิน, พนักงานต้อนรับบนเครื่องบิน, ทหาร, ตำรวจ หรืออาสาสมัคร และเข้าปฏิบัติการในสงคราม หรือปราบปราม",
        },
        {
          index:
            "6. ขณะที่ผู้เอาประกันภัยเข้าร่วมเล่นหรือฝึกซ้อมหรือแข่งขันกีฬาอาชีพ",
        },
      ],
    },
    {
      title: "",
      detail:
        "กรมธรรม์ประกันภัยนี้ไม่คุ้มครองผู้ที่เดินทางไปหรือการเดินทางภายในประเทศต่อไปนี้: ",
      items: [
        {
          index:
            "เกาหลีเหนือ, คิวบา, ซีเรีย, ซูดาน, บุรุนดี, ปากีสถาน, ปาเลสไตน์, รวันดา, ลิเบีย, เลบานอน, ไลบีเรีย, อัฟกานิสถาน, อาเซอร์ไบจาน, อิรัก, อิสราเอล, อิหร่าน, อุซเบกิสถาน, เอธิโอเปีย, เอริเทรีย, แองโกลา, แอลจีเรีย และเฮติ",
        },
      ],
    },
    {
      title: "",
      detail: "**หมายเหตุ",
      items: [
        {
          index:
            "ข้อ 2 การรักษาพยาบาลในต่างประเทศ จากการบาดเจ็บจากอุบัติเหตุ หรือการเจ็บป่วยที่เกิดขึ้นอย่างกะทันหัน จนเป็นเหตุให้ต้องได้รับการรักษาพยาบาล ไม่ว่าจะเป็นฐานะผู้ป่วยในหรือผู้ป่วยนอก",
        },
        {
          index:
            "ข้อ 3 การรักษาพยาบาลต่อเนื่องในประเทศไทยคุ้มครองค่ารักษาพยาบาลที่จำเป็นในการรักษาหรือการติดตามอาการในประเทศไทย",
        },
        {
          index:
            "1. กรณีไม่เคยรักษาพยาบาลในต่างประเทศมาก่อน ต้องรับการรักษาในประเทศไทยภายใน 1 วัน นับจากเดินทางมาถึงประเทศไทย และรักษาต่อเนื่องไม่เกิน 7 วัน",
        },
        {
          index:
            "2. กรณีเคยรักษาในต่างประเทศมาก่อน ต้องเข้ารับการรักษาภายใน 7 วันนับจากเดินทางกลับถึงประเทศไทย",
        },
        {
          index:
            "ข้อ 4. ผลประโยชน์ชดเชยระหว่างการรักษาตัวในโรงพยาบาลในฐานะผู้ป่วยใน บริษัทจะจ่ายผลประโยชน์ชดเชยรายวันให้เป็นจำนวนต่อวัน ตามจำนวนวันที่นอนรักษาตัวเป็นผู้ป่วยในในโรงพยาบาล ในต่างประเทศจริง สูงสุดไม่เกิน 20 วัน",
        },
        {
          index:
            "ข้อ 5. การเลื่อน หรือการบอกเลิกการเดินทาง ซึ่งเกิดขึ้นภายใน 30 วัน ก่อนวันออกเดินทาง (ยกเว้นสาเหตุตามข้อ 3) อันมีสาเหตุมาจาก",
        },
        {
          index:
            "1. การเสียชีวิต หรือการบาดเจ็บสาหัสหรือการเจ็บป่วยหนักของผู้เอาประกันภัย หรือสมาชิกของครอบครัว",
        },
        {
          index:
            "2. การเกิดการนัดหยุดงานขึ้นโดยไม่คาดคิด การจลาจล สงครามกลางเมือง ซึ่งเป็นเหตุการณ์ที่อยู่นอกเหนือการควบคุมของผู้เอาประกันภัย",
        },
        {
          index:
            "3. เมื่อที่พักอาศัยของผู้เอาประกันภัยที่ใช้เป็นที่อยู่อาศัยถาวรได้รับความเสียหายร้ายแรงจาก ไฟไหม้ น้ำท่วม พายุใต้ฝุ่น แผ่นดินไหว ภายใน 7 วัน ก่อนวันออกเดินทาง",
        },
        {
          index:
            "4. ได้รับหมายเรียกให้เป็นพยานที่ศาล หรือได้รับหมายบังคับจากศาล",
        },
        {
          index:
            "ข้อ 6. ค่าใช้จ่ายในการลดจำนวนวันเดินทาง ให้ความคุ้มครองค่าใช้จ่ายที่เพิ่มขึ้นที่ได้ชำระไปสำหรับค่าใช้จ่ายในการเดินทาง ค่าที่พัก และค่าอาหารในระหว่างระยะเวลาการเดินทาง กรณีต้องเดินทางกลับประเทศภูมิลำเนาก่อนกำหนดเนื่องจาก",
        },
        {
          index:
            "1. ผู้เอาประกันภัยได้รับการบาดเจ็บสาหัสหรือการป่วยหนัก และแพทย์แนะนำให้เดินทางกลับ",
        },
        {
          index:
            "2. สมาชิกของครอบครัว หรือเพื่อนเดินทางของผู้เอาประกันภัย เสียชีวิต หรือได้รับการบาดเจ็บ หรือการเจ็บป่วยโดยไม่คาดหมาย",
        },
        {
          index:
            "3. ภัยธรรมชาติ ได้แก่ พายุไต้ฝุ่น หรือแผ่นดินไหว ทำให้ผู้เอาประกันภัยไม่สามารถเดินทางตามกำหนดการต่อไปได้",
        },
        {
          index:
            "4. การนัดหยุดงาน การจลาจล การก่อความวุ่นวายทางการเมืองที่ไม่คาดหมายและอยู่นอกเหนือ การควบคุมของผู้เอาประกันภัย หรือ",
        },
        {
          index: "5. การถูกกักด่านกักกันเชื้อโรคตามคำแนะนำของแพทย์",
        },
        {
          index:
            "ข้อ 8. ชดเชยความล่าช้าในการเดินทาง กรณีการเดินทางล่าช้าออกไปจากกำหนดการเดินทางเป็นเวลาอย่างน้อย 6 ชั่วโมง ติดต่อกัน เนื่องจากสภาพอากาศไม่อำนวย เครื่องอุปกรณ์ไม่สมบูรณ์ หรือการนัดหยุดงาน",
        },
        {
          index:
            "ข้อ 9. การพลาดการต่อเที่ยวบิน กรณีที่พลาดการเดินทางต่อในต่างประเทศ ณ จุดที่ต้องมีการเปลี่ยนถ่ายยานพาหนะ อันเนื่องมาจากการล่าช้า 8 ชั่วโมง",
        },
        {
          index:
            "ข้อ 11. ชดเชยการสูญหายของเงินส่วนตัว จะต้องรับผิดชอบความเสียหายส่วนแรกเป็นจำนวนเงิน 1,000 บาท ของการสูญหาย แต่ละครั้งและทุกๆ ครั้งที่เกิดการสูญหาย",
        },
        {
          index: "ข้อ 12. การล่าช้าของกระเป๋าเดินทาง",
        },
        {
          index:
            "1. หลังจากมาถึงจุดหมายปลายทางในต่างประเทศเกินกว่า 8 ชั่วโมง จะชดใช้เงินคืนตามที่ได้สำรองจ่ายไปจริงล่วงหน้าสูงสุดไม่เกินร้อยละ 20 ของจำนวนเงินเอาประกันภัย",
        },
        {
          index:
            "2. หลังจากมาถึงจุดหมายปลายทางในต่างประเทศเกินกว่า 16 ชั่วโมง จะชดใช้เงินคืนเป็นจำนวนเงินที่เพิ่มเติมจากข้อ 1 อีกไม่เกินร้อยละ 30 ของจำนวนเงินเอาประกันภัย",
        },
        {
          index:
            "3. หลังจากมาถึงจุดหมายปลายทางในต่างประเทศเกินกว่า 24 ชั่วโมง จะชดใช้เงินคืนเป็นจำนวนเงินที่เพิ่มเติมจากข้อ 2 อีกไม่เกินร้อยละ 50 ของจำนวนเงินเอาประกันภัย ",
        },
        {
          index:
            "ข้อ 15. การขยายระยะเวลาโดยอัตโนมัติ กรณีที่การเดินทางในเที่ยวกลับต้องล่าช้าออกไปเนื่องจากมีเหตุการณ์อยู่นอกเหนือความควบคุม จะขยายระยะเวลาของการประกันภัยเท่าที่จำเป็นสำหรับให้  ไม่เกิน 30 วัน",
        },
        {
          index:
            "ข้อ 17. ชดเชยค่าโทรศัพท์ในกรณีฉุกเฉิน เพื่อจุดประสงค์ในการติดต่อขอใช้บริการของ บริษัท AWP Services (Thailand) Co.,Ltd. เท่านั้น",
        },
        {
          index:
            "ข้อ 18.ค่าใช้จ่ายในเดินทางเพื่อเยี่ยมผู้ป่วยที่โรงพยาบาล กรณีที่เข้ารับการรักษาตัวเป็นผู้ป่วยในในโรงพยาบาล ในต่างประเทศติดต่อกันนานเกิน 5 วัน และไม่มีบุคคลที่บรรลุนิติภาวะอยู่ด้วยจะจ่ายค่าเดินทางเฉพาะค่าเดินทางรวมทั้งจ่ายค่าที่พัก และค่าอาหารสูงสุด 50,000 บาท",
        },
      ],
    },
  ],
  services: [
    {
      title: "",
      detail:
        "Allianz Global Assistance <br/> (ภายใต้การบริหารของ AWP Services (Thailand) Co.,Ltd.)",
      items: [
        {
          index:
            "<li> บริการข้อมูลก่อนการเดินทาง เช่น การขอวีซ่า สภาพภูมิอากาศ อัตราแลกเปลี่ยนเงินตรา เป็นต้น",
        },
        {
          index: "<li> ให้คำแนะนำด้านการแพทย์",
        },
        {
          index: "<li> บริการข้อมูลเกี่ยวกับโรงพยาบาล แพทย์ คลินิก",
        },
        {
          index:
            "<li> บริการเคลื่อนย้ายฉุกเฉินเพื่อรักษาพยาบาล หรือส่งกลับประเทศไทย",
        },
        {
          index: "<li> บริการวางเงินประกันค่ารักษาพยาบาลกับโรงพยาบาล",
        },
        {
          index: "<li> ให้คำแนะนำเมื่อทรัพย์สิน/หนังสือเดินทาง เกิดสูญหาย",
        },
        {
          index: "<li> บริการข้อมูลเพื่อติดต่อสถานทูต หรือสถานกงสุล",
        },
        {
          index: "<li> บริการข้อมูลเพื่อติดต่อสำนักกฎหมาย",
        },
        {
          index: "<li> ติดต่อเพื่อขอรับบริการโทร.02-342-3214",
        },
      ],
    },
  ],
};

export default consent;
